import {
  GET_ERRORS
} from "../actions/types";

const initialState = null;

export default function (state = initialState, action) {
	switch (action.type) {
		case GET_ERRORS:
			return action.payload ?? state;
		default:
			return state;
	}
}